import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'latitude-ui-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss']
})
export class ToggleComponent implements OnInit {

  private _checked = true;

  @Input()
  get checked(): boolean { return this._checked; }
  set checked(value) { this._checked = value; this.onChangeCallback(this._checked); }
  @Input() label: string;

  @Input() class = '';

  @Output() change = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() { }

  isChecked() {
    return this.checked === true;
  }

  toggleChecked() {
    this.checked = !this.checked;
    this.change.emit(this.checked);
  }

  writeValue(value: any): void {
    this._checked = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  private onTouchedCallback = () => { /* Placeholder */ };

  private onChangeCallback = (_: any) => { /* Placeholder */ };

}



// WEBPACK FOOTER //
// ./src/latitude-ui/toggle/toggle.component.ts